import { ITripRoomGuest } from "@cruisen/contract"
import { TripRoomID } from "@cruisen/contract"
import { useStores } from "../models/helpers/useStores"

export const useGuestActions = () => {
  const rootStore = useStores()

  const removeGuestFromRoom = async (guestId: string, roomId: TripRoomID) => {
    rootStore.setProp("activeTrip", {
      ...rootStore.activeTrip,
      rooms: rootStore.activeTrip?.rooms.map((room) => {
        if (room.id === roomId) {
          return { ...room, guests: room.guests.filter((guest) => guest.id !== guestId) }
        }
        return room
      }),
    })
  }

  const addGuestToRoom = async (guest: ITripRoomGuest, roomId: TripRoomID) => {
    rootStore.setProp("activeTrip", {
      ...rootStore.activeTrip,
      rooms: rootStore.activeTrip?.rooms.map((room) => {
        if (room.id === roomId) {
          return { ...room, guests: [...room.guests, guest] }
        }
        return room
      }),
    })
  }

  const moveGuestToRoom = async (
    guest: ITripRoomGuest,
    roomId: TripRoomID,
    newRoomId: TripRoomID,
  ) => {
    rootStore.setProp("activeTrip", {
      ...rootStore.activeTrip,
      rooms: rootStore.activeTrip?.rooms.map((room) => {
        if (room.id === roomId) {
          return { ...room, guests: room.guests.filter((g) => g.id !== guest.id) }
        }
        if (room.id === newRoomId) {
          return { ...room, guests: [...room.guests, guest] }
        }
        return room
      }),
    })
  }

  return { removeGuestFromRoom, addGuestToRoom, moveGuestToRoom }
}
